import React, { useCallback, useMemo, useRef } from 'react';
import Filter from '@/pages/dashboard/components/NewFilter';
import moment, { Moment } from 'moment';
import { timeTypeObj } from '@/pages/dashboard/_config/constant';
import { setBtnPointLog } from '@/pages/dashboard/utils/utils';
import { renderCompetitor, renderSource } from './FilterList';
import { useFilterData } from './hooks';
import { RANGE_DATE } from '../../components/NewFilter/FilterBase/_config';
import { getDateDefault } from '../../utils/dateUtils';
import { shallowEqual, useSelector } from 'umi';

// 日期格式化
const formatDateFromFilterValue = (value: any, selector: any): any => {
  const { rangeTime: { type, value: val }, competitor } = value || {};
  const { competitor_list: competitorList = [] } = selector;
  const currentGame = competitorList?.filter((item: any) => !item?.is_competitor)?.[0];
  const allCompetitors = competitorList?.filter((item: any) => item?.is_competitor);
  const selectedCompetitors = competitor?.map((val: string) => allCompetitors?.find((item: any) => item?.unified_id === val)).filter(Boolean);
  const [start, end] = val;
  const format = timeTypeObj.Day;
  return {
    ...value,
    competitor: [currentGame, ...selectedCompetitors],
    rangeTime: {
      type,
      value: [start.format(format), end.format(format)]
    }
  };
};
// 筛选器路径

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

// InsightFilter筛选器继承逻辑
const InsightFilter = (props: any) => {
  const { filterConfirm, filterReset, filterInit, buttonLogConfig, openSticky = false, competitorReqType } = props;
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新
  const FILTER_PATH = '/competitor/index';
  const { loading, selectorSchemeList, getOutSelectorSchemeList, selector } = useFilterData(FILTER_PATH);
  const timeZone = useSelector((state: any) => (parseInt(state?.dashboardSetting?.gameConfig?.time_zone || '', 10) || 0), shallowEqual);
  // 设置inputList
  const inputList = useMemo(() => {
    if (loading) return [];
    const { source_list: sourceList, competitor_list: competitorList } = selector;
    const sourceDefault = sourceList?.find((item: any) => item?.value === 'sensortower') || sourceList?.[0];

    return [
      {
        type: RANGE_DATE,
        key: 'rangeTime',
        default: {
          type: 'month',
          value: getDateDefault({ timeType: 'month', timeZone, startNum: 6, endNum: 1 }),
        },
        componentDefault: {
          date: getDateDefault({ timeType: 'day', timeZone, startNum: 30, endNum: 1 }),
          week: getDateDefault({ timeType: 'week', timeZone, startNum: 8, endNum: 1 }),
          month: getDateDefault({ timeType: 'month', timeZone, startNum: 6, endNum: 1 }),
        },
        typeList: competitorReqType === "normal" ? ['date', 'week', 'month'] : ['week', 'month'],
        disabledDate: {
          date: (date: Moment, start: Moment) => {
            const isAfterToday = date.isAfter(moment(), "day");
            const isTwoYearsBefore = moment(date).isAfter(moment(start).add(2, "years"));
            const isTwoYearsAfter = moment(date).isBefore(moment(start).subtract(2, "years"));
            if (moment.isMoment(start)) {
              return (
                !isAfterToday &&
                !(
                  isTwoYearsBefore || isTwoYearsAfter
                )
              );
            }
            return !isAfterToday;
          },
        },
        startOfDate: moment().subtract(2, 'years')?.format('YYYY-MM-DD')
      },
      {
        key: 'competitor',
        default: (competitorList || []).map((item: any) => item.unified_id),
        render: renderCompetitor
      },
      {
        key: 'region',
        default: {
          region_type: 'market',
          markets: ["255"],
          regions: []
        },
      },
      {
        key: 'system',
        default: ["255"],
      },
      {
        key: 'source',
        optionDataKey: 'source_list',
        default: sourceDefault?.value || '',
        render: renderSource
      }
    ];
  }, [loading]);

  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback((value) => {
    filterValueRef.current = value;
    // todo 锁定状态下如果锁定时间跟默认时间相同，是否需要单独处理，设置diff为false？
    filterInit({
      filterValue: formatDateFromFilterValue(value, selector),
      newFilter: true,
    });
  }, [filterInit, selector]);

  const onConfirm = useCallback((value) => {
    filterValueRef.current = value;
    const obj: any = {
      filterValue: formatDateFromFilterValue(value, selector),
      newFilter: true,
    };
    filterConfirm(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, obj?.filterValue);
  }, [filterConfirm, selector]);

  const onReset = useCallback((value) => {
    filterValueRef.current = value;
    const obj = {
      filterValue: formatDateFromFilterValue(value, selector),
      newFilter: true,
    };
    filterReset(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, obj?.filterValue, true);
  }, [filterReset, selector]);

  // const handleChange = (key: string, value: any) => {
  //   if (key === 'rangeTime') {
  //     filterValueRef.current = {
  //       ...filterValueRef.current,
  //       [key]: {
  //         type: value.type,
  //         value: value.value,
  //       },
  //     };
  //   }
  // };

  return < Filter
    openSticky={openSticky}
    path={FILTER_PATH}
    // isHaveFilterSave={false}
    value={filterValueRef.current}
    latestDateType={''}
    inputList={inputList}
    onInit={onInit}
    onConfirm={onConfirm}
    onReset={onReset}
    // onChange={handleChange}
    // isHaveFilterCache={false}
    loading={loading}
    useOutInput={true}
    outSelector={selector}
    outSelectorSchemeList={selectorSchemeList}
    getOutSelectorSchemeList={getOutSelectorSchemeList}
  />;
};

export default InsightFilter;
